import { render, staticRenderFns } from "./RecordInfoModal.vue?vue&type=template&id=47bc01d6&scoped=true"
import script from "./RecordInfoModal.vue?vue&type=script&lang=js"
export * from "./RecordInfoModal.vue?vue&type=script&lang=js"
import style0 from "./RecordInfoModal.vue?vue&type=style&index=0&id=47bc01d6&prod&lang=scss&scoped=true"
import style1 from "./RecordInfoModal.vue?vue&type=style&index=1&id=47bc01d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bc01d6",
  null
  
)

export default component.exports